// JavaScript
import Vue from 'vue'

import '../javascripts/company_radar_chart'
import '../javascripts/company_bar_chart'
import StarPopover from '../javascripts/components/StarPopover'

const starPopoverList = document.querySelectorAll('.js-star-popover')
const starPopover = Array.prototype.slice.call(starPopoverList, 0) // IE11 対策
if (starPopover.length) {
  starPopover.forEach((el) => {
    new Vue({
      el,
      components: {
        StarPopover,
      },
    })
  })
}
